const ironAndFoldWomen = [
	{
		id: '3201',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Top Wear (Shirt / T-shirt / Fatua)',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 10,
		quantity: 1
	},

	{
		id: '3202',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bottom Wear ( Trouser / Slack / Pazama)',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 10,
		quantity: 1
	},

	{
		id: '3203',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Long Dress (Borka / Jumpsuit / Arabian Dress)',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 20,
		quantity: 1
	},
	{
		id: '3204',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Inner Wear (Blous / Petticoat / Under Garments)',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 12,
		quantity: 1
	},
	{
		id: '3205',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Plain Cotton / Plain Silk / Cotton Design)',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 40,
		quantity: 1
	},

	{
		id: '3206',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree - Exclusive (Benarasi / Jamdani / Katan)',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 60,
		quantity: 1
	},

	{
		id: '3207',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kameez / Kaftan / Apron / Tops',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 80,
		quantity: 1
	},
	{
		id: '3208',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Exclusive Kameez',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 30,
		quantity: 1
	},
	{
		id: '3209',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Accessories (Scarf / Dupatta / Orna / Muffler)',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 10,
		quantity: 1
	},

	{
		id: '3210',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Winter Wear (Sweater / Cardigan)',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 25,
		quantity: 1
    },
    
	{
		id: '3211',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Home Wear (Nightdress / Normal Maxi)',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 12,
		quantity: 1
    },
    
	{
		id: '3212',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Waist Coat/ Coati',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 30,
		quantity: 1
    },
    
	{
		id: '3213',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Skirt',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 40,
		quantity: 1
    },
    
	{
		id: '3214',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kameez (2 Pcs)',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 20,
		quantity: 1
    },
    
	{
		id: '3215',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kameez (3 Pcs)',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 30,
		quantity: 1
    },
    
	{
		id: '3216',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Skirt Suit (2 Pcs)',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 70,
		quantity: 1
    },
    
	{
		id: '3217',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Shawl',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 30,
		quantity: 1
    },
    
	{
		id: '3218',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blazer / Coat / Jacket',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 60,
		quantity: 1
    },
    
	{
		id: '3219',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Leather Jacket',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 450,
		quantity: 1
    },
    
	{
		id: '3219',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Overcoat',
		category: "Women's Wear",
		service: 'Iron And Fold',
		price: 300,
		quantity: 1
	}
];

export default ironAndFoldWomen;
